// Тексты профиля /tutors/<slug> (28.10.2026): «Haqqımda», «Davamı», плашка
// «Şəkil əlavə edin» владельцу, «Yaxınlıqda başqa repetitorlar».
// Ничего сверх данных анкеты: ни отзывов, ни рейтингов, ни «проверено».
import type { SiteLang } from "@/components/site/SiteChrome";

type Kind = "tutor" | "club";

export const PROFILE_COPY: Record<
  SiteLang,
  {
    about: Record<Kind, string>;
    more: string;
    less: string;
    photoHint: string;
    photoHintLink: string;
    nearby: Record<Kind, string>;
    sameSubject: Record<Kind, string>;
    /** Ссылки на страницы предметов анкеты (29.10.2026). */
    subjectPages: string;
  }
> = {
  az: {
    about: { tutor: "Haqqımda", club: "Haqqımızda" },
    more: "Davamı",
    less: "Qısalt",
    photoHint: "Şəkil əlavə edin — valideynlər şəkilli anketlərə daha çox yazır",
    photoHintLink: "Kabinet",
    nearby: { tutor: "Yaxınlıqda başqa repetitorlar", club: "Yaxınlıqda başqa dərnəklər" },
    sameSubject: { tutor: "Bu fəndən başqa repetitorlar", club: "Bu sahədən başqa dərnəklər" },
    subjectPages: "Fənn üzrə bütün repetitorlar",
  },
  ru: {
    about: { tutor: "О себе", club: "О нас" },
    more: "Читать дальше",
    less: "Свернуть",
    photoHint: "Добавьте фото — родители чаще пишут по анкетам с фото",
    photoHintLink: "Кабинет",
    nearby: { tutor: "Ещё репетиторы рядом", club: "Ещё кружки рядом" },
    sameSubject: { tutor: "Ещё репетиторы по этому предмету", club: "Ещё кружки по этому направлению" },
    subjectPages: "Все репетиторы по предмету",
  },
  en: {
    about: { tutor: "About me", club: "About us" },
    more: "Read more",
    less: "Show less",
    photoHint: "Add a photo — parents write more often to profiles with a photo",
    photoHintLink: "Dashboard",
    nearby: { tutor: "Other tutors nearby", club: "Other clubs nearby" },
    sameSubject: { tutor: "Other tutors for this subject", club: "Other clubs in this area" },
    subjectPages: "All tutors by subject",
  },
};
